import { CategoryDef } from '../types';

export const sortCategories = (codes: string[], defs: CategoryDef[]): string[] => {
  const orderByCode = new Map(
    defs.filter(d => d.order !== undefined).map(d => [d.code, d.order as number]),
  );
  const withOrder = codes
    .filter(c => orderByCode.has(c))
    .sort((a, b) => orderByCode.get(a)! - orderByCode.get(b)!);
  const withoutOrder = codes.filter(c => !orderByCode.has(c));
  return [...withOrder, ...withoutOrder];
};
